import type React from 'react';

interface GlassContainerProps {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    borderRadius?: string;
    padding?: string;
    showShadow?: boolean; // Controls whether box-shadow is applied (default: true)
    showBorder?: boolean; // Controls whether border is applied (default: true)
    // Data attributes for analytics
    'data-ph-capture-attribute-input-area'?: string;
    'data-ph-capture-attribute-view-type'?: string;
    'data-ph-capture-attribute-site'?: string;
}

const GlassContainer: React.FC<GlassContainerProps> = ({
    children,
    className = '',
    style = {},
    borderRadius = 'var(--rw-radius-shell-compact)',
    padding = '8px',
    showShadow = true,
    showBorder = true,
    ...dataAttributes
}) => {
    // Apple-style glassmorphism with saturation boost, subtle border, and soft shadow
    const glassStyle: React.CSSProperties = {
        background: 'var(--rw-bg-search-shell)',
        borderRadius,
        padding,
        border: showBorder ? '1px solid var(--rw-border-glass)' : undefined,
        boxShadow: showShadow ? 'var(--rw-shadow-shell-elevated)' : 'none',
        backdropFilter: 'blur(var(--rw-glass-blur)) saturate(var(--rw-glass-saturate))',
        WebkitBackdropFilter: 'blur(var(--rw-glass-blur)) saturate(var(--rw-glass-saturate))',
        ...style,
    };

    return (
        <div
            className={`rose-widget-glass-container ${className}`}
            style={glassStyle}
            {...dataAttributes}
        >
            {children}
        </div>
    );
};

export default GlassContainer;
